// What PCD's "Process meeting AI" button tells the doctor, from
// soapNotesAiPostMeeting's reply (pythoncloudfunctions main.py).
//
// A call that was never transcribed is answered 200 with
// { status: false, message: "No transcript found for this call" }. A failed save
// is ALSO 200 with status false, but its message is the success text
// ("Transcript and summary saved successfully"), so status false alone can't
// mean "no transcript": only that answer (or a noTranscript flag, if the
// function ever passes it through) is a warning; any other status false is an error.
//
// Returns 'started' | 'no_transcript' | 'error'.
export const meetingAiOutcome = (ok, body) => {
    if (!ok) return 'error';
    if (body && body.status === false) {
        if (body.noTranscript === true || /no transcript/i.test(body.message || '')) return 'no_transcript';
        return 'error';
    }
    return 'started';
};
